import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26a7d3fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message"
}

import { ComputedRef, computed, watch, onUnmounted } from "vue";

const __default__ = {
  name: 'ResponseAlert'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: { 
    show: { type: Boolean, required: true },
    message: { type: String, required: true },
    success: { type: Boolean, required: true },
},
  emits: ['changeShow'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "689fe4d7": (messageBackground.value),
  "2c8feee9": (messageButtonBackground.value),
  "cbf63aa2": (messageButtonHoverBackground.value)
}))

const emit = __emit

// Props
const props = __props;

let hideTimer: ReturnType<typeof setTimeout> | null = null;

const clearHideTimer = () => {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
};

// Methods
const emitShow = (show: boolean) => {
  if (!show) clearHideTimer();
  emit('changeShow', show);
};

watch(
  () => props.show,
  (isVisible) => {
    clearHideTimer();
    if (!isVisible) return;
    hideTimer = setTimeout(() => emitShow(false), 5000);
  }
);

onUnmounted(clearHideTimer);

// Computed 
const messageBackground: ComputedRef<string> = computed(() => props.success ? 'var(--light-green-pecsmart)' : 'var(--error-light-red)');
const messageButtonBackground: ComputedRef<string> = computed(() => props.success ? 'var(--btn-green)' : 'var(--error-lighter-red)');
const messageButtonHoverBackground: ComputedRef<string> = computed(() => props.success ? 'var(--btn-hover-green)' : 'var(--error-dark-red)');

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(props.message), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emitShow(false)))
        }, "X")
      ]))
    : _createCommentVNode("", true)
}
}

})